/**
 * PDP Product Gallery + UGC Strip
 * Tab 1: Product shots with dot indicators
 * Tab 2: UGC carousel grouped by person, size-aware
 * Supports gallery swap for v2 pack selector carousel hero
 */
(function(){
  var container=document.getElementById('pdp-gallery');
  if(!container)return;
  var TN=container.getAttribute('data-tenant')||'';
  var productHandle=container.getAttribute('data-handle')||'';
  var productId=container.getAttribute('data-product-id')||'';
  var productName=container.getAttribute('data-product-name')||'';
  var _origHandle=productHandle;
  var _origProductId=productId;
  var _origProductName=productName;
  var CDN='https://'+TN+'.myshopishop.com';
  var track=document.getElementById('pdp-ugc-track');
  var tabsEl=document.getElementById('pdp-person-tabs');
  if(!track||!tabsEl)return;

  // ---- Gallery swap cache ----
  var _ugcCache={};      // handle → {items:[], popularItems:[]}
  var _productImgCache={}; // handle → {images:[], id:''}
  var _preloadQueue=[];
  var _preloading=false;

  // ---- Tab switching ----
  var activeTab='product';
  var tabButtons=container.querySelectorAll('.pdp-tab');
  var tabProduct=document.getElementById('pdp-tab-product');
  var tabUgc=document.getElementById('pdp-tab-ugc');
  var tabPopular=document.getElementById('pdp-tab-popular');
  var popularTrack=document.getElementById('pdp-popular-track');
  var tabBar=document.getElementById('pdp-gallery-tabs');
  var _hasUgc=false;

  function switchTab(tab){
    activeTab=tab;
    tabButtons.forEach(function(b){
      var isActive=b.getAttribute('data-tab')===tab;
      b.style.color=isActive?'#1f2937':'#9ca3af';
      b.style.borderTopColor=isActive?'#1f2937':'transparent';
    });
    if(tabProduct)tabProduct.style.display=tab==='product'?'block':'none';
    tabUgc.style.display=tab==='ugc'?'block':'none';
    if(tabPopular)tabPopular.style.display=tab==='popular'?'block':'none';
    // Pause videos when not on their tab
    if(tab!=='ugc'){track.querySelectorAll('video').forEach(function(v){try{v.pause();}catch(e){}});}
    if(tab!=='popular'&&popularTrack){popularTrack.querySelectorAll('video').forEach(function(v){try{v.pause();}catch(e){}});}
    // Autoplay visible videos on active tab
    if(tab==='popular'&&popularTrack){
      var firstVid=popularTrack.querySelector('video');
      if(firstVid)try{firstVid.play();}catch(e){}
    }
  }

  function _showTabBar(){
    if(tabBar)tabBar.style.display='flex';
    _hasUgc=true;
  }
  function _hideTabBar(){
    if(tabBar)tabBar.style.display='none';
    _hasUgc=false;
  }

  tabButtons.forEach(function(b){
    b.addEventListener('click',function(){switchTab(b.getAttribute('data-tab'));});
  });

  // ---- Product image dots ----
  var productTrack=document.getElementById('pdp-product-track');
  var dots=container.querySelectorAll('.pdp-dot');
  if(productTrack&&dots.length>1){
    // Scroll to image on dot click
    dots.forEach(function(dot){
      dot.addEventListener('click',function(){
        var idx=parseInt(dot.getAttribute('data-idx'),10);
        var child=productTrack.children[idx];
        if(child)productTrack.scrollTo({left:child.offsetLeft,behavior:'smooth'});
      });
    });
    // Update dots on scroll
    var scrollTimer=null;
    productTrack.addEventListener('scroll',function(){
      if(scrollTimer)clearTimeout(scrollTimer);
      scrollTimer=setTimeout(function(){
        var sl=productTrack.scrollLeft;
        var w=productTrack.offsetWidth;
        var idx=Math.round(sl/w);
        dots.forEach(function(d,i){
          d.style.background=i===idx?'#1f2937':'#d1d5db';
        });
      },60);
    });
  }

  // ---- UGC logic (existing, adapted) ----
  function ru(u){if(!u)return'';return u.startsWith('http')?u:CDN+(u.startsWith('/')?'':'/')+u;}

  var PACK_HANDLES=['7-8-mat-pocket-leggings-black','emama-longline-crop','shorts-mat-pocket-black','pregnancy-recovery-emama-7-8-leggings-pockets','pregnancy-recovery-emama-shorts-pockets'];
  var PACK_NAMES={'7-8-mat-pocket-leggings-black':'7/8 Maternity Leggings + Pockets','emama-longline-crop':'Nursing Crop','shorts-mat-pocket-black':'Maternity Shorts + Pockets','pregnancy-recovery-emama-7-8-leggings-pockets':'7/8 Recovery Leggings + Pockets','pregnancy-recovery-emama-shorts-pockets':'Recovery Shorts + Pockets'};
  var STAGE_LABELS={t1:'in her 1st trimester',t2:'in her 2nd trimester',t3:'in her 3rd trimester',p:'post partum',k:'living her mum life'};
  var STAGE_ORDER=['t1','t2','t3','p','k'];
  var SIZE_ORDER=['XXS','XS','S','M','L','XL','XXL','3XL','4XL'];

  var allUgc=[];
  var personGroups={};
  var personOrder=[];
  var activePerson=null;
  var soundOn=false;
  var selectedSize=null;
  var ugcLoaded=false;

  // --- Size helpers ---
  function parseSizes(str){
    if(!str)return[];
    return str.split(',').map(function(s){return s.trim().toUpperCase();}).filter(Boolean);
  }
  function getItemSizes(item){
    var b=parseSizes(item.bottoms);
    var t=parseSizes(item.tops);
    return b.length?b:t;
  }
  function sizeDistance(a,b){
    var ai=SIZE_ORDER.indexOf(a.toUpperCase());
    var bi=SIZE_ORDER.indexOf(b.toUpperCase());
    if(ai<0||bi<0)return 999;
    return Math.abs(ai-bi);
  }
  function smallestSizeIdx(sizes){
    var best=999;
    for(var i=0;i<sizes.length;i++){var idx=SIZE_ORDER.indexOf(sizes[i]);if(idx>=0&&idx<best)best=idx;}
    return best;
  }
  function sortBySize(items,targetSize){
    if(!targetSize)return items;
    var target=targetSize.toUpperCase();
    return items.slice().sort(function(a,b){
      var aSizes=getItemSizes(a),bSizes=getItemSizes(b);
      var aExact=aSizes.indexOf(target)>=0?0:1;
      var bExact=bSizes.indexOf(target)>=0?0:1;
      if(aExact!==bExact)return aExact-bExact;
      var aDist=999,bDist=999;
      for(var i=0;i<aSizes.length;i++){var d=sizeDistance(aSizes[i],target);if(d<aDist)aDist=d;}
      for(var i=0;i<bSizes.length;i++){var d=sizeDistance(bSizes[i],target);if(d<bDist)bDist=d;}
      if(aDist!==bDist)return aDist-bDist;
      return smallestSizeIdx(aSizes)-smallestSizeIdx(bSizes);
    });
  }
  function bestSize(item){
    var sizes=getItemSizes(item);
    var target=readSelectedSize();
    if(sizes.length){
      if(!target)return sizes[0];
      for(var i=0;i<sizes.length;i++){if(sizes[i]===target)return sizes[i];}
      var best=sizes[0],bestD=sizeDistance(sizes[0],target);
      for(var i=1;i<sizes.length;i++){var d=sizeDistance(sizes[i],target);if(d<bestD){best=sizes[i];bestD=d;}}
      return best;
    }
    return target;
  }

  // --- Product variant cache ---
  var productCache={};
  var productCacheLoading={};
  function fetchProductData(handle,cb){
    if(productCache[handle]){cb(productCache[handle]);return;}
    if(productCacheLoading[handle]){productCacheLoading[handle].push(cb);return;}
    productCacheLoading[handle]=[cb];
    fetch('/products/'+handle+'.js').then(function(r){return r.json();}).then(function(data){
      productCache[handle]=data;
      var cbs=productCacheLoading[handle]||[];
      delete productCacheLoading[handle];
      cbs.forEach(function(fn){fn(data);});
    }).catch(function(){delete productCacheLoading[handle];});
  }
  function prefetchProducts(items){
    var seen={};
    items.forEach(function(it){
      if(!it.products)return;
      it.products.forEach(function(p){
        if(p.handle&&!seen[p.handle]){seen[p.handle]=true;fetchProductData(p.handle,function(){});}
      });
    });
  }
  function getVariantId(handle,size){
    var data=productCache[handle];
    if(!data||!data.variants)return null;
    var sz=size.toUpperCase();
    for(var i=0;i<data.variants.length;i++){
      var v=data.variants[i];
      if(v.available&&v.title.toUpperCase()===sz)return v.id;
    }
    return null;
  }
  function readSelectedSize(){
    var sel=document.querySelector('#size-buttons button.selected');
    if(sel){
      var txt=sel.textContent.trim();
      var match=txt.match(/^([A-Z0-9]+)/i);
      if(match)return match[1].toUpperCase();
    }
    return null;
  }

  // --- Content helpers ---
  function stageText(item){
    if(item.trimester&&STAGE_LABELS[item.trimester])return STAGE_LABELS[item.trimester];
    if(item.stage==='m')return'in her pregnancy';
    if(item.stage==='p')return STAGE_LABELS.p;
    if(item.stage==='k')return STAGE_LABELS.k;
    return'';
  }
  function cleanTitle(title){
    if(!title)return'';
    return title.replace(/\s*[-\u2013]?\s*FINAL SALE.*/i,'').trim();
  }
  function isTopProduct(name){
    var n=(name||'').toLowerCase();
    return n.indexOf('crop')>=0||n.indexOf('nursing')>=0||n.indexOf('bra')>=0||n.indexOf('top')>=0;
  }
  function sizeForProduct(item,prodName){
    var target=readSelectedSize();
    var useTop=isTopProduct(prodName);
    var tagged=parseSizes(useTop?item.tops:item.bottoms);
    if(!tagged.length)tagged=parseSizes(useTop?item.bottoms:item.tops);
    if(tagged.length){
      if(!target)return tagged[0];
      for(var i=0;i<tagged.length;i++){if(tagged[i]===target)return tagged[i];}
      var best=tagged[0],bestD=sizeDistance(tagged[0],target);
      for(var i=1;i<tagged.length;i++){var d=sizeDistance(tagged[i],target);if(d<bestD){best=tagged[i];bestD=d;}}
      return best;
    }
    return target;
  }
  function productLines(item){
    if(!item.products||!item.products.length)return[];
    var all=[];
    var seen={};
    item.products.forEach(function(prod){
      var name=PACK_NAMES[prod.handle]||cleanTitle(prod.title);
      if(!name||seen[name])return;
      seen[name]=true;
      var isTop=isTopProduct(name);
      all.push({name:name,handle:prod.handle,isTop:isTop});
    });
    // Pick max 1 bottom + 1 top. Prioritize the current PDP product.
    var bottom=null,top=null;
    // First pass: look for PDP product
    for(var i=0;i<all.length;i++){
      if(all[i].handle===productHandle){
        if(all[i].isTop){top=all[i];}else{bottom=all[i];}
      }
    }
    // Second pass: fill remaining slot
    for(var i=0;i<all.length;i++){
      if(!bottom&&!all[i].isTop){bottom=all[i];}
      if(!top&&all[i].isTop){top=all[i];}
    }
    var lines=[];
    if(bottom)lines.push(bottom);
    if(top)lines.push(top);
    return lines;
  }

  function buildInfoHtml(item){
    var h='<div style="padding:8px 10px;background:#111;font-size:11px;color:rgba(255,255,255,0.8);line-height:1.5;">';
    var intro='this is <strong>@'+(item.handle||'unknown')+'</strong>';
    var stage=stageText(item);
    if(stage)intro+=' '+stage;
    h+='<div>'+intro+'</div>';
    var prods=productLines(item);
    if(prods.length){
      h+='<div style="margin-top:3px;">she\u2019s wearing:</div>';
      prods.forEach(function(p,i){
        var prefix=i>0?'& ':'';
        h+='<div>'+prefix+p.name+'</div>';
        var sz=sizeForProduct(item,p.name);
        if(sz){
          var atcBadge='';
          if(p.handle){
            var vid=getVariantId(p.handle,sz);
            if(vid){
              atcBadge=' <span class="ugc-atc-btn" data-variant-id="'+vid+'" style="display:inline-block;font-size:8px;font-weight:700;text-transform:uppercase;background:#E8846C;color:#fff;padding:2px 6px;margin-left:4px;cursor:pointer;">add to cart</span>';
            }
          }
          h+='<div style="color:rgba(255,255,255,0.5);">size '+sz+atcBadge+'</div>';
        }
      });
    }
    h+='</div>';
    return h;
  }

  function buildCardHtml(it){
    var isV=it.type==='reel'||it.type==='video';
    var h='<div style="background:#000;overflow:hidden;position:relative;">';
    if(isV)h+='<video src="'+ru(it.url)+'" poster="'+ru(it.posterUrl||'')+'" playsinline loop muted preload="metadata" style="width:100%;aspect-ratio:3/4;object-fit:cover;display:block;"></video>';
    else h+='<img src="'+ru(it.url)+'" style="width:100%;aspect-ratio:3/4;object-fit:cover;display:block;" loading="lazy">';
    h+='</div>';
    h+=buildInfoHtml(it);
    return h;
  }

  // --- Sound toggle ---
  function addSoundBtn(el){
    el.querySelectorAll('video').forEach(function(vid){
      if(vid.parentElement.querySelector('.pdp-sound-btn'))return;
      vid.muted=!soundOn;
      var btn=document.createElement('button');
      btn.className='pdp-sound-btn';btn.type='button';
      btn.style.cssText='position:absolute;bottom:10px;right:10px;width:32px;height:32px;border-radius:50%;background:rgba(0,0,0,0.6);border:none;cursor:pointer;display:flex;align-items:center;justify-content:center;z-index:5;';
      btn.innerHTML=soundOn?'\uD83D\uDD0A':'\uD83D\uDD07';
      btn.addEventListener('click',function(e){
        e.stopPropagation();
        soundOn=!soundOn;
        document.querySelectorAll('video').forEach(function(v){v.muted=!soundOn;});
        document.querySelectorAll('.pdp-sound-btn').forEach(function(b){b.innerHTML=soundOn?'\uD83D\uDD0A':'\uD83D\uDD07';});
      });
      vid.parentElement.appendChild(btn);
    });
  }

  // --- ATC wiring helper ---
  function wireAtcButtons(parent){
    parent.querySelectorAll('.ugc-atc-btn').forEach(function(btn){
      btn.addEventListener('click',function(e){
        e.stopPropagation();
        var vid=btn.getAttribute('data-variant-id');
        if(!vid)return;
        btn.textContent='adding...';
        // _em_* line properties (leading underscore = hidden from cart UI /
        // emails but persisted into order.line_items[*].properties so
        // purchase-side attribution can join back to the ATC surface).
        // See scripts/emamaco-cvr-tracker.js readEmLineProps() and
        // app/worker/src/integrations/emamaco-funnel-order-projection.ts
        // readEmProps() for downstream parsing.
        var emProps={
          _em_source:'pdp_ugc',
          _em_atc_type:'ugc_single',
          _em_pack_qty:'1',
          _em_size:(typeof selectedSize!=='undefined'?selectedSize:'')||'',
          _em_parent_handle:(typeof activePerson!=='undefined'?activePerson:'')||'',
          _em_component_handle:btn.getAttribute('data-product-handle')||''
        };
        fetch('/cart/add.js',{
          method:'POST',
          headers:{'Content-Type':'application/json','Accept':'application/json'},
          body:JSON.stringify({id:Number(vid),quantity:1,properties:emProps})
        }).then(function(){
          btn.textContent='added!';
          btn.style.background='#3D9A8B';
          setTimeout(function(){btn.textContent='add to cart';btn.style.background='#E8846C';},2000);
        }).catch(function(){btn.textContent='add to cart';});
      });
    });
  }

  // --- Render person carousel ---
  function renderPerson(handle){
    activePerson=handle;
    track.innerHTML='';

    tabsEl.querySelectorAll('button').forEach(function(b){
      var isActive=b.getAttribute('data-handle')===handle;
      b.style.background=isActive?'#1f2937':'#f3f4f6';
      b.style.color=isActive?'#fff':'#6b7280';
    });

    var items=(personGroups[handle]||[]).slice();
    selectedSize=readSelectedSize();
    if(selectedSize){
      items=sortBySize(items,selectedSize);
    } else {
      items.sort(function(a,b){
        var aK=a.trimester||(a.stage==='p'?'p':a.stage==='k'?'k':'z');
        var bK=b.trimester||(b.stage==='p'?'p':b.stage==='k'?'k':'z');
        return STAGE_ORDER.indexOf(aK)-STAGE_ORDER.indexOf(bK);
      });
    }

    items.forEach(function(it){
      var card=document.createElement('div');
      card.style.cssText='flex:0 0 85%;max-width:85%;scroll-snap-align:start;overflow:hidden;background:#000;cursor:pointer;';
      card.innerHTML=buildCardHtml(it);
      addSoundBtn(card);
      wireAtcButtons(card);
      card.addEventListener('click',function(e){
        if(e.target.closest('.pdp-sound-btn')||e.target.closest('.ugc-atc-btn'))return;
        openModal(allUgc,it.id);
      });
      var vid=card.querySelector('video');
      if(vid&&'IntersectionObserver' in window){
        new IntersectionObserver(function(entries){
          var v=entries[0].target;
          if(entries[0].isIntersecting){
            track.querySelectorAll('video').forEach(function(ov){if(ov!==v)try{ov.pause();}catch(ex){}});
            try{v.play();}catch(ex){}
          }else{try{v.pause();}catch(ex){}}
        },{threshold:0.5}).observe(vid);
      }
      track.appendChild(card);
    });
  }

  function onPdpSizeChange(){
    var newSize=readSelectedSize();
    if(newSize!==selectedSize&&activePerson){
      selectedSize=newSize;
      renderPerson(activePerson);
    }
  }

  // --- Update tab badge ---
  function updateUgcTabBadge(count){
    var ugcTab=container.querySelector('[data-tab="ugc"]');
    if(ugcTab){
      ugcTab.textContent=count>0?'As Seen on Social Media ('+count+')':'As Seen on Social Media';
    }
  }

  // --- Load UGC ---
  // Pulls per-product items from window.__cmMap.byProduct[productHandle].
  // The published map is sorted DESC by id, matching the legacy API's order.
  // Memoised so loadStrip + loadPopularSimple share the same materialised
  // list. Returns [] on any failure — same shape as a successful empty
  // response from the legacy /api/ugc-gallery call.
  var _stripItemsPromise=null;
  function loadStripFromMap(){
    if(_stripItemsPromise)return _stripItemsPromise;
    _stripItemsPromise=new Promise(function(resolve){
      function build(){
        var m=window.__cmMap;
        if(!m||!m.byProduct||!m.media)return resolve([]);
        var ids=m.byProduct[productHandle]||[];
        var out=[];
        for(var i=0;i<ids.length&&out.length<100;i++){
          var e=m.media[ids[i]];
          if(!e)continue;
          out.push({
            id:Number(ids[i]),
            url:e.url,
            posterUrl:e.poster||null,
            type:e.type,
            handle:e.handle||null,
            stage:e.stage||null,
            trimester:e.trimester||null,
            tops:e.tops||null,
            bottoms:e.bottoms||null,
            sourcePrefix:e.sourcePrefix||null
          });
        }
        resolve(out);
      }
      if(window.__cmMap)return build();
      if(window.__cm&&typeof window.__cm.then==='function')return window.__cm.then(build).catch(function(){resolve([]);});
      resolve([]);
    });
    return _stripItemsPromise;
  }

  function loadStrip(){
    loadStripFromMap().then(function(items){
      // Cache UGC data for this product
      _ugcCache[productHandle]=_ugcCache[productHandle]||{items:[],popularItems:[]};
      if(!items.length){
        return;
      }

      allUgc=items;
      ugcLoaded=true;
      prefetchProducts(items);

      // Update tab badge
      updateUgcTabBadge(items.length);

      // Group by person
      items.forEach(function(it){
        if(!it.handle)return;
        if(!personGroups[it.handle]){personGroups[it.handle]=[];personOrder.push(it.handle);}
        personGroups[it.handle].push(it);
      });

      if(!personOrder.length)return;

      // Build person tabs
      tabsEl.innerHTML='';
      personOrder.forEach(function(handle){
        var btn=document.createElement('button');
        btn.type='button';
        btn.setAttribute('data-handle',handle);
        btn.textContent='@'+handle;
        btn.style.cssText='flex-shrink:0;padding:6px 12px;font-size:12px;font-weight:600;border:none;cursor:pointer;font-family:system-ui,-apple-system,sans-serif;transition:all 0.15s;background:#f3f4f6;color:#6b7280;';
        btn.addEventListener('click',function(){renderPerson(handle);});
        tabsEl.appendChild(btn);
      });

      // Fade edges on person tabs scroll
      var fadeL=document.getElementById('pdp-fade-left');
      var fadeR=document.getElementById('pdp-fade-right');
      function updateFades(){
        if(!fadeL||!fadeR)return;
        var sl=tabsEl.scrollLeft;
        var maxScroll=tabsEl.scrollWidth-tabsEl.clientWidth;
        fadeL.style.display=sl>4?'block':'none';
        fadeR.style.display=maxScroll-sl>4?'block':'none';
      }
      tabsEl.addEventListener('scroll',updateFades);
      // Initial check after tabs render
      setTimeout(updateFades,100);

      // Pre-render first person (will show when user clicks UGC tab)
      renderPerson(personOrder[0]);
      // Re-render after product cache populates
      setTimeout(function(){if(activePerson)renderPerson(activePerson);updateFades();},800);

      // Listen for size changes
      var sizeRow=document.getElementById('size-buttons');
      if(sizeRow){
        sizeRow.addEventListener('click',function(){
          setTimeout(onPdpSizeChange,50);
        });
      }
    }).catch(function(){});
  }

  // --- Modal ---
  var savedScrollY=0;
  function lockBody(){
    savedScrollY=window.scrollY;
    document.body.style.position='fixed';
    document.body.style.top='-'+savedScrollY+'px';
    document.body.style.left='0';
    document.body.style.right='0';
    document.body.style.overflow='hidden';
  }
  function unlockBody(){
    document.body.style.position='';
    document.body.style.top='';
    document.body.style.left='';
    document.body.style.right='';
    document.body.style.overflow='';
    window.scrollTo(0,savedScrollY);
  }

  function openModal(items,focusId){
    if(window.openUgcModal){window.openUgcModal(items,focusId);return;}

    lockBody();
    var el=document.createElement('div');
    el.style.cssText='position:fixed;inset:0;z-index:99999;background:#000;display:flex;flex-direction:column;';
    var ci=0;
    for(var i=0;i<items.length;i++){if(items[i].id===focusId){ci=i;break;}}

    function closeModal(){unlockBody();el.remove();}

    function render(){
      var h='<div style="position:sticky;top:0;z-index:10;display:flex;justify-content:flex-end;padding:12px 16px;background:rgba(0,0,0,0.8);"><button id="pdp-mx" style="color:white;background:none;border:none;font-size:20px;cursor:pointer;">\u2715</button></div>';
      h+='<div style="flex:1;overflow-y:auto;">';

      var groups={},order=[];
      items.forEach(function(it){var key=it.handle||('_'+it.id);if(!groups[key]){groups[key]=[];order.push(key);}groups[key].push(it);});
      var focusedHandle=items[ci]?items[ci].handle:null;
      if(focusedHandle&&order.indexOf(focusedHandle)>0){order.splice(order.indexOf(focusedHandle),1);order.unshift(focusedHandle);}

      order.forEach(function(handle){
        var pItems=groups[handle];
        var sz=readSelectedSize();
        if(sz){pItems=sortBySize(pItems,sz);}
        else{pItems=pItems.slice().sort(function(a,b){
          var aK=a.trimester||(a.stage==='p'?'p':a.stage==='k'?'k':'z');
          var bK=b.trimester||(b.stage==='p'?'p':b.stage==='k'?'k':'z');
          return STAGE_ORDER.indexOf(aK)-STAGE_ORDER.indexOf(bK);
        });}
        h+='<div style="padding:12px 16px 6px;font-size:14px;font-weight:700;color:white;">@'+handle+'</div>';
        h+='<div style="display:flex;gap:2px;overflow-x:auto;scroll-snap-type:x mandatory;-webkit-overflow-scrolling:touch;scrollbar-width:none;padding:0 0 12px 0;">';
        pItems.forEach(function(it){
          h+='<div style="flex:0 0 85%;max-width:85%;scroll-snap-align:start;overflow:hidden;background:#000;">'+buildCardHtml(it)+'</div>';
        });
        h+='</div>';
      });

      h+='</div>';
      el.innerHTML=h;
      el.querySelector('#pdp-mx').addEventListener('click',closeModal);
      wireAtcButtons(el);
    }

    document.body.appendChild(el);
    render();
  }

  loadStrip();

  // ---- Most Popular tab ----
  // `loadPopular()` (the follower-sorted variant that hit /api/ugc-gallery +
  // /api/ugc-people) was retired before this rewrite — only loadPopularSimple
  // is wired up. KNOWN_TOP_HANDLES is the curator's hand-picked priority list
  // used as the popularity sort key in loadPopularSimple below.
  var KNOWN_TOP_HANDLES=['hannahpolites','belle_lucia','skye.wheatley','tayla.broad','yasminscottofficial','dominiqueletoullec','katrinagorry10','marianneknerr','tahny89','bybrittanynoonan','laurenkvickers','coach_amandajane'];

  function loadPopularSimple(){
    if(!popularTrack)return;
    // Same window.__cmMap source as loadStrip — the memoised Promise above
    // means this resolves without any extra work after the first call.
    loadStripFromMap().then(function(stripItems){
      if(!stripItems.length)return;

      var items=stripItems.slice();
      items.sort(function(a,b){
        var aVid=(a.type==='reel'||a.type==='video')?0:1;
        var bVid=(b.type==='reel'||b.type==='video')?0:1;
        if(aVid!==bVid)return aVid-bVid;
        var aIdx=KNOWN_TOP_HANDLES.indexOf(a.handle);
        var bIdx=KNOWN_TOP_HANDLES.indexOf(b.handle);
        if(aIdx<0)aIdx=999;if(bIdx<0)bIdx=999;
        return aIdx-bIdx;
      });

      var seen={},top=[];
      for(var i=0;i<items.length&&top.length<10;i++){
        var h=items[i].handle;
        if(h&&seen[h])continue;if(h)seen[h]=true;top.push(items[i]);
      }
      if(!top.length)return;

      popularTrack.innerHTML='';
      top.forEach(function(it){
        var isV=it.type==='reel'||it.type==='video';
        var url=ru(it.url);var poster=ru(it.posterUrl||'');
        var card=document.createElement('div');
        card.style.cssText='flex:0 0 85%;max-width:85%;scroll-snap-align:start;overflow:hidden;background:#000;position:relative;cursor:pointer;';
        var media;
        if(isV){
          media='<video src="'+url+'" poster="'+poster+'" playsinline loop muted preload="metadata" style="width:100%;aspect-ratio:3/4;object-fit:cover;display:block;"></video>';
          // Poster overlay covers the video element until the first frame is
          // actually decoded.  <video poster> only paints while paused — once
          // play() is called the poster vanishes, exposing the video element's
          // black background during the metadata→first-frame buffer gap.  The
          // overlay below stays visible until the `playing` event fires (real
          // first frame ready), then fades out.  Reappears on `pause`.
          if(poster)media+='<img class="pdp-poster-overlay" src="'+poster+'" style="position:absolute;top:0;left:0;width:100%;height:100%;object-fit:cover;display:block;pointer-events:none;transition:opacity 0.15s linear;">';
        } else {
          media='<img src="'+url+'" style="width:100%;aspect-ratio:3/4;object-fit:cover;display:block;" loading="lazy">';
        }

        var overlay='<div style="position:absolute;bottom:12px;left:12px;right:12px;color:white;text-shadow:0 1px 4px rgba(0,0,0,0.7);font-family:system-ui,-apple-system,sans-serif;">';
        overlay+='<div style="font-size:15px;font-weight:700;">@'+(it.handle||'')+'</div>';
        var sl=stageText(it);
        if(sl)overlay+='<div style="font-size:12px;margin-top:2px;">'+sl+'</div>';
        var wearSize=parseSizes(it.tops).length?parseSizes(it.tops)[0]:(parseSizes(it.bottoms).length?parseSizes(it.bottoms)[0]:'');
        if(wearSize)overlay+='<div style="font-size:12px;margin-top:2px;">wears size '+wearSize+'</div>';
        overlay+='</div>';
        card.innerHTML=media+overlay;
        addSoundBtn(card);
        // Wire poster-overlay fade for video cards
        var _vid=card.querySelector('video');
        var _ov=card.querySelector('.pdp-poster-overlay');
        if(_vid&&_ov){
          _vid.addEventListener('playing',function(){_ov.style.opacity='0';});
          _vid.addEventListener('pause',function(){_ov.style.opacity='1';});
        }
        card.addEventListener('click',function(e){
          if(e.target.closest('.pdp-sound-btn'))return;
          openModal(allUgc.length?allUgc:top,it.id);
        });
        popularTrack.appendChild(card);
      });

      if('IntersectionObserver' in window){
        popularTrack.querySelectorAll('video').forEach(function(vid){
          new IntersectionObserver(function(entries){
            if(entries[0].isIntersecting){
              popularTrack.querySelectorAll('video').forEach(function(ov){if(ov!==entries[0].target)try{ov.pause();}catch(e){}});
              try{entries[0].target.play();}catch(e){}
            }else{try{entries[0].target.pause();}catch(e){}}
          },{threshold:0.5}).observe(vid);
        });
      }

      // UGC exists — reveal the tab bar AND switch to Most Popular as the
      // default tab.  Defaulting to Product Photos on first paint dropped
      // CVR by ~50% — Most Popular is the conversion driver.  The
      // black-flash on swipe is masked by the .pdp-poster-overlay <img>
      // we render on each video card (lines 702-710): it covers the
      // <video> element's buffer gap and only fades on the `playing`
      // event, so the user never sees the black frame.
      //
      // EXCEPTION (28 Jul, agreed): a product whose mapped media is ALL
      // widely-shared filler (every id mapped to 4+ products — the generic
      // collection reel) opens on Product Photos instead — its "popular"
      // shows the WRONG products, which is the CVR-negative case. Products
      // with ANY dedicated media keep the popular-first default untouched.
      _showTabBar();
      switchTab(_mappedAllGeneric(productHandle)?'product':'popular');
    }).catch(function(){});
  }

  // True when EVERY media id mapped to this handle is shared across 4+
  // products; dedicated content (shared 1-3x) keeps this false. Share
  // counts are computed once and cached on the map object.
  function _mappedAllGeneric(handle){
    try{
      var m=window.__cmMap;
      if(!m||!m.byProduct||!m.media)return false;
      var ids=m.byProduct[handle]||[];
      if(!ids.length)return false;
      if(!m.__shareCount){
        var sc={};
        Object.keys(m.byProduct).forEach(function(h){
          (m.byProduct[h]||[]).forEach(function(id){sc[id]=(sc[id]||0)+1;});
        });
        m.__shareCount=sc;
      }
      for(var i=0;i<ids.length;i++){
        if((m.__shareCount[ids[i]]||0)<4)return false;
      }
      return true;
    }catch(e){return false;}
  }

  loadPopularSimple();

  // ---- Gallery swap for v2 carousel hero ----

  // Cache the original product's images from Liquid-rendered DOM
  (function cacheOrigProductPhotos(){
    var origTrack=document.getElementById('pdp-product-track');
    if(!origTrack)return;
    var imgs=[];
    origTrack.querySelectorAll('img').forEach(function(img){imgs.push(img.src);});
    _productImgCache[_origHandle]={images:imgs,id:_origProductId};
  })();

  function _rebuildProductPhotos(handle){
    // Honor an active variant (colour) filter set by packprice's image strip —
    // it persists across pdpGallerySwap so the carousel keeps showing only the
    // selected colour's images. Null/empty filter → fall back to the full
    // cached product gallery.
    var filter=window.__pdpColourFilter;
    var cached=_productImgCache[handle];
    var images=(filter&&filter.length)?filter:(cached&&cached.images);
    if(!images||!images.length)return;
    var trackEl=document.getElementById('pdp-product-track');
    if(!trackEl)return;
    trackEl.innerHTML='';
    images.forEach(function(src,i){
      var div=document.createElement('div');
      div.style.cssText='flex:0 0 85%;max-width:85%;scroll-snap-align:start;';
      var img=document.createElement('img');
      img.src=src;
      img.alt='';
      img.style.cssText='width:100%;aspect-ratio:3/4;object-fit:cover;display:block;';
      img.loading=i===0?'eager':'lazy';
      div.appendChild(img);
      trackEl.appendChild(div);
    });
  }

  // Drive the product-photos carousel from an explicit list of image srcs (one
  // colour's images). Sets the persistent filter so a later pdpGallerySwap keeps
  // it. switchToProduct=true surfaces the Product Photos tab (used on an explicit
  // colour click); omit it on initial/auto so a UGC product keeps its default tab.
  window.pdpGalleryShowImages=function(srcs, switchToProduct){
    window.__pdpColourFilter=(srcs&&srcs.length)?srcs:null;
    if(!window.__pdpColourFilter)return;
    _rebuildProductPhotos(productHandle||_origHandle);
    if(switchToProduct){try{switchTab('product');}catch(e){}}
  };

  function _rebuildUgcFromCache(handle){
    var cached=_ugcCache[handle];
    var emptyEl=document.getElementById('pdp-ugc-empty');
    if(!cached||!cached.items||!cached.items.length){
      // No UGC for this product
      track.innerHTML='';
      tabsEl.innerHTML='';
      if(emptyEl)emptyEl.style.display='';
      updateUgcTabBadge(0);
      return;
    }
    if(emptyEl)emptyEl.style.display='none';

    // Rebuild person groups
    allUgc=cached.items;
    ugcLoaded=true;
    personGroups={};personOrder=[];activePerson=null;
    cached.items.forEach(function(it){
      if(!it.handle)return;
      if(!personGroups[it.handle]){personGroups[it.handle]=[];personOrder.push(it.handle);}
      personGroups[it.handle].push(it);
    });
    updateUgcTabBadge(cached.items.length);
    if(!personOrder.length)return;

    // Rebuild person tabs
    tabsEl.innerHTML='';
    personOrder.forEach(function(h){
      var btn=document.createElement('button');
      btn.type='button';btn.setAttribute('data-handle',h);
      btn.textContent='@'+h;
      btn.style.cssText='flex-shrink:0;padding:6px 12px;font-size:12px;font-weight:600;border:none;cursor:pointer;font-family:system-ui,-apple-system,sans-serif;transition:all 0.15s;background:#f3f4f6;color:#6b7280;';
      btn.addEventListener('click',function(){renderPerson(h);});
      tabsEl.appendChild(btn);
    });
    renderPerson(personOrder[0]);
    prefetchProducts(cached.items);
    setTimeout(function(){if(activePerson)renderPerson(activePerson);},800);
  }

  function _rebuildPopularFromCache(handle){
    var cached=_ugcCache[handle];
    if(!popularTrack)return;
    if(!cached||!cached.popularItems||!cached.popularItems.length){
      popularTrack.innerHTML='';
      return false;
    }
    var top=cached.popularItems;
    popularTrack.innerHTML='';
    top.forEach(function(it){
      var isV=it.type==='reel'||it.type==='video';
      var url=ru(it.url);var poster=ru(it.posterUrl||'');
      var card=document.createElement('div');
      card.style.cssText='flex:0 0 85%;max-width:85%;scroll-snap-align:start;overflow:hidden;background:#000;position:relative;cursor:pointer;';
      var media;
      if(isV)media='<video src="'+url+'" poster="'+poster+'" playsinline loop muted preload="metadata" style="width:100%;aspect-ratio:3/4;object-fit:cover;display:block;"></video>';
      else media='<img src="'+url+'" style="width:100%;aspect-ratio:3/4;object-fit:cover;display:block;" loading="lazy">';
      var overlay='<div style="position:absolute;bottom:12px;left:12px;right:12px;color:white;text-shadow:0 1px 4px rgba(0,0,0,0.7);font-family:system-ui,-apple-system,sans-serif;">';
      overlay+='<div style="font-size:15px;font-weight:700;">@'+(it.handle||'')+'</div>';
      var sl=stageText(it);
      if(sl)overlay+='<div style="font-size:12px;margin-top:2px;">'+sl+'</div>';
      var wearSize=parseSizes(it.tops).length?parseSizes(it.tops)[0]:(parseSizes(it.bottoms).length?parseSizes(it.bottoms)[0]:'');
      if(wearSize)overlay+='<div style="font-size:12px;margin-top:2px;">wears size '+wearSize+'</div>';
      overlay+='</div>';
      card.innerHTML=media+overlay;
      addSoundBtn(card);
      card.addEventListener('click',function(e){
        if(e.target.closest('.pdp-sound-btn'))return;
        openModal(allUgc.length?allUgc:top,it.id);
      });
      popularTrack.appendChild(card);
    });
    // Video autoplay
    if('IntersectionObserver' in window){
      popularTrack.querySelectorAll('video').forEach(function(vid){
        new IntersectionObserver(function(entries){
          if(entries[0].isIntersecting){
            popularTrack.querySelectorAll('video').forEach(function(ov){if(ov!==entries[0].target)try{ov.pause();}catch(e){}});
            try{entries[0].target.play();}catch(e){}
          }else{try{entries[0].target.pause();}catch(e){}}
        },{threshold:0.5}).observe(vid);
      });
    }
    return true;
  }

  // Main swap function — rebuilds all tabs from cache, fetches on demand if needed
  function _doSwap(handle){
    // Rebuild product photos tab
    _rebuildProductPhotos(handle);

    // Rebuild UGC tabs from cache
    _rebuildUgcFromCache(handle);

    // Rebuild popular tab
    var hasPopular=_rebuildPopularFromCache(handle);

    // Show/hide tab bar based on content.  After a cross-product swap we
    // restore Most Popular as the active tab — defaulting to Product
    // Photos costs ~50% CVR.  Black-flash on swipe is handled by the
    // per-card .pdp-poster-overlay <img> (covers the video's buffer gap
    // and fades on the `playing` event), so the swap to popular is no
    // longer jarring.  Same all-generic exception as first load: filler-only
    // products open on Product Photos.
    if(hasPopular){
      _showTabBar();
      switchTab(_mappedAllGeneric(handle)?'product':'popular');
    } else {
      _hideTabBar();
      if(tabProduct)tabProduct.style.display='';
      if(tabPopular)tabPopular.style.display='none';
      tabUgc.style.display='none';
    }
  }

  window.pdpGallerySwap=function(handle){
    if(!handle)handle=_origHandle;
    productHandle=handle;

    var cached=_productImgCache[handle];
    if(cached){
      productId=cached.id;
      container.setAttribute('data-handle',handle);
      container.setAttribute('data-product-id',cached.id);
      _doSwap(handle);
    } else {
      // Cache miss — fetch product data first, then swap
      _fetchAndCacheProduct(handle).then(function(){
        var c=_productImgCache[handle];
        if(c){productId=c.id;container.setAttribute('data-handle',handle);container.setAttribute('data-product-id',c.id);}
        return _fetchAndCacheUgc(handle);
      }).then(function(){
        _doSwap(handle);
      });
    }
  };

  // Preload function — called from v2 packprice during idle
  function _fetchAndCacheProduct(handle){
    if(_productImgCache[handle])return Promise.resolve();
    return fetch('/products/'+handle+'.js').then(function(r){return r.json();}).then(function(data){
      var imgs=[];
      if(data.images)data.images.forEach(function(img){
        // Get 800w version
        var sized=img.replace(/\.([a-z]+)\?/,'_800x.$1?');
        if(img.indexOf('width=')>=0)sized=img;
        else sized=img+(img.indexOf('?')>=0?'&':'?')+'width=800';
        imgs.push(sized);
      });
      _productImgCache[handle]={images:imgs,id:String(data.id)};
    }).catch(function(){});
  }

  // Variant of loadStripFromMap for an arbitrary product handle — used by the
  // background preloader (_preloadNext) which warms the cache for handles
  // beyond the current PDP. Same shape as loadStripFromMap; not memoised per
  // handle since results are stored in _ugcCache[handle].
  function _fetchUgcFromMap(handle){
    function build(){
      var m=window.__cmMap;
      if(!m||!m.byProduct||!m.media)return [];
      var ids=m.byProduct[handle]||[];
      var out=[];
      for(var i=0;i<ids.length&&out.length<100;i++){
        var e=m.media[ids[i]];
        if(!e)continue;
        out.push({
          id:Number(ids[i]),
          url:e.url,
          posterUrl:e.poster||null,
          type:e.type,
          handle:e.handle||null,
          stage:e.stage||null,
          trimester:e.trimester||null,
          tops:e.tops||null,
          bottoms:e.bottoms||null,
          sourcePrefix:e.sourcePrefix||null
        });
      }
      return out;
    }
    if(window.__cmMap)return Promise.resolve(build());
    if(window.__cm&&typeof window.__cm.then==='function')return window.__cm.then(build).catch(function(){return [];});
    return Promise.resolve([]);
  }

  function _fetchAndCacheUgc(handle){
    if(_ugcCache[handle])return Promise.resolve();
    var cached=_productImgCache[handle];
    if(!cached)return Promise.resolve();
    return _fetchUgcFromMap(handle).then(function(items){
      if(!items.length){_ugcCache[handle]={items:[],popularItems:[]};return;}
      // Build popular list (same logic as loadPopularSimple)
      var sorted=items.slice().sort(function(a,b){
        var aVid=(a.type==='reel'||a.type==='video')?0:1;
        var bVid=(b.type==='reel'||b.type==='video')?0:1;
        if(aVid!==bVid)return aVid-bVid;
        var aIdx=KNOWN_TOP_HANDLES.indexOf(a.handle);var bIdx=KNOWN_TOP_HANDLES.indexOf(b.handle);
        if(aIdx<0)aIdx=999;if(bIdx<0)bIdx=999;
        return aIdx-bIdx;
      });
      var seen={},top=[];
      for(var i=0;i<sorted.length&&top.length<10;i++){
        var h=sorted[i].handle;
        if(h&&seen[h])continue;if(h)seen[h]=true;top.push(sorted[i]);
      }
      _ugcCache[handle]={items:items,popularItems:top};
    }).catch(function(){_ugcCache[handle]={items:[],popularItems:[]};});
  }

  // Background preloader — processes handles one at a time to avoid flooding
  function _preloadNext(){
    if(!_preloadQueue.length){_preloading=false;return;}
    var handle=_preloadQueue.shift();
    _fetchAndCacheProduct(handle).then(function(){
      return _fetchAndCacheUgc(handle);
    }).then(function(){
      setTimeout(_preloadNext,100);
    });
  }

  window._v2GalleryPreload=function(handles){
    handles.forEach(function(h){
      if(h!==_origHandle&&_preloadQueue.indexOf(h)<0&&!_productImgCache[h]){
        _preloadQueue.push(h);
      }
    });
    if(!_preloading){_preloading=true;_preloadNext();}
  };

  // Also cache the initial product's UGC so swap back is instant
  // (loadStrip already does this, but let's store in our cache format too)
  var _origLoadStripDone=false;
  var _origStripInterval=setInterval(function(){
    if(ugcLoaded||_origLoadStripDone){
      clearInterval(_origStripInterval);
      _origLoadStripDone=true;
      if(!_ugcCache[_origHandle]){
        // Build cache from already-loaded data
        var sorted=allUgc.slice().sort(function(a,b){
          var aVid=(a.type==='reel'||a.type==='video')?0:1;
          var bVid=(b.type==='reel'||b.type==='video')?0:1;
          if(aVid!==bVid)return aVid-bVid;
          var aIdx=KNOWN_TOP_HANDLES.indexOf(a.handle);var bIdx=KNOWN_TOP_HANDLES.indexOf(b.handle);
          if(aIdx<0)aIdx=999;if(bIdx<0)bIdx=999;
          return aIdx-bIdx;
        });
        var seen={},top=[];
        for(var i=0;i<sorted.length&&top.length<10;i++){
          var h=sorted[i].handle;if(h&&seen[h])continue;if(h)seen[h]=true;top.push(sorted[i]);
        }
        _ugcCache[_origHandle]={items:allUgc,popularItems:top};
      }
    }
  },500);
})();

